import * as React from "react"
import {
  SelectConnectedField,
  SelectConnectedFieldProps,
} from "gatsby-interface"
import { PERSONAL_TEAM_ID } from "../utils"

export type VercelTeamFieldProps = Omit<
  SelectConnectedFieldProps,
  "options"
> & {
  siteId: string
  teams: Record<string, string>[]
  loading: boolean
}

export function VercelTeamField({
  siteId,
  teams,
  loading,
  ...rest
}: VercelTeamFieldProps) {
  const teamOptions = React.useMemo<
    SelectConnectedFieldProps["options"]
  >(() => {
    return teams.map(({ id, slug, name }) => {
      if (id === PERSONAL_TEAM_ID) {
        return {
          value: id,
          label: name,
        }
      }

      return {
        value: slug,
        label: name,
      }
    })
  }, [teams])

  return (
    <SelectConnectedField options={teamOptions} disabled={loading} {...rest} />
  )
}
